import Invoices from "@/pages/Invoices";

export default function BonsLivraison() {
    return (
        <Invoices
            fixedType="bon_livraison"
            overline="Bons de livraison"
            title="Tous vos bons de livraison"
            itemLabel={{ singular: "bon de livraison", plural: "bons de livraison" }}
        />
    );
}
